import React from 'react';
import { Card, CardBody, Col } from 'reactstrap';
import { LI, UL } from '../../../../AbstractElements';
import { ContextualClasses, Dangertext, Darktext, Defaultitem2, Infotext, Ligthtext, Primarytext, Secondarytext, Successtext, Warningtext } from '../../../../Constant';
import HeaderCard from '../../../Common/HeaderCard';

const ContextualClass = () => {
  return (
    <Col sm='6' xl='6'>
      <Card>
        <HeaderCard title={ContextualClasses} />
        <CardBody>
          <UL className='default-list'>
            <LI className='list-group-item'>{Defaultitem2}</LI>
            <LI className='list-group-item list-group-item-primary'>{Primarytext}</LI>
            <LI className='list-group-item list-group-item-secondary'>{Secondarytext}</LI>
            <LI className='list-group-item list-group-item-success'>{Successtext}</LI>
            <LI className='list-group-item list-group-item-danger'>{Dangertext}</LI>
            <LI className='list-group-item list-group-item-warning'>{Warningtext}</LI>
            <LI className='list-group-item list-group-item-info'>{Infotext}</LI>
            <LI className='list-group-item list-group-item-light'>{Ligthtext}</LI>
            <LI className='list-group-item list-group-item-dark'>{Darktext}</LI>
          </UL>
        </CardBody>
      </Card>
    </Col>
  );
};

export default ContextualClass;
